import { NotificationAlertOverride } from ".";

export const TaxVerified: NotificationAlertOverride = () => ({
  theme: "success",
  icon: "check-circle"
});
